import cookieService from '@/services/cookie-service'
import { UserInformation } from '@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
    const xsrfToken = ref<string | null>(null)
    const isAuth = ref(false)
    const user = ref<UserInformation | null>()
    const adminCartLoaded = ref(false)

    return {
        getUser() {
            return user.value
        },
        setUser(value: UserInformation | null) {
            user.value = value
        },
        getIsAuth() {
            return isAuth.value
        },
        setIsAuth(value: boolean) {
            isAuth.value = value
            return isAuth
        },
        getXsrfToken() {
            return xsrfToken.value
        },
        setXsrfToken() {
            try {
                const result = cookieService.getCookie('XSRF-TOKEN') ?? ''
                xsrfToken.value = result
            } catch (err) {
                console.log(err)
            }
            return xsrfToken
        },
        clearAuthSession() {
            // Keep Xsrf token - just clear user data
            this.setIsAuth(false)
            this.setUser(null)
        },
        getAdminCartLoaded() {
            return adminCartLoaded.value
        },
        setAdminCartLoaded(val: boolean) {
            adminCartLoaded.value = val
            return adminCartLoaded
        }
    }
})